module.exports = __webpack_public_path__ + "img/extended.e83cf326.png";